/* PlanJapon — achat direct depuis l'accueil (sections plans-grid et home-buy, 2026-09-27).

   Chaque carte est un vrai formulaire `/cart/add` (form 'product') : c'est pj-cart.js qui
   l'intercepte, ajoute l'eSIM ET les cadeaux dans la même requête et ouvre le tiroir panier,
   exactement comme depuis la fiche produit. Ce script ne fait que piloter la carte :
   - illimité : − / + parcourent les durées réelles (1 → 30 j), puis des séjours de 35 à 90 j
     couverts par plusieurs eSIM (même règle et même arithmétique que le calendrier de la PDP :
     30 jours, puis le reste arrondi au forfait supérieur, remise native −5 % à 2 eSIM, −10 %
     dès 3, arrondie par eSIM). Un séjour découpé a besoin de DATES (chaque eSIM porte sa date
     d'activation, relue par n8n) : le bouton d'achat cède alors la place à « Choisir mes dates »,
     qui ouvre le calendrier de la fiche produit (?sejour=N) ;
   - data : 10 / 20 / 50 Go, prix et prix au Go suivent ;
   - le champ caché `id` porte toujours la variante affichée. */
(function () {
  'use strict';

  function money(cfg) {
    var ISO = cfg.iso || 'EUR', CUR = cfg.cur || '€', DEC = 2;
    try { DEC = new Intl.NumberFormat('en', { style: 'currency', currency: ISO }).resolvedOptions().maximumFractionDigits; } catch (e) {}
    var F = Math.pow(10, DEC);
    var num = function (v) {
      var p = v.toFixed(DEC).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + (p[1] ? ',' + p[1] : '');
    };
    var fmt = function (v) { return num(v) + ' ' + CUR; };
    /* Hors euro : présentation du filtre money lue sur un montant témoin (123 456 700 cents). */
    if (ISO !== 'EUR' && cfg.money) {
      var ta = document.createElement('textarea'); ta.innerHTML = cfg.money;
      var mf = ta.value.replace(/[  ]/g, ' ').match(/^(\D*)1(\D?)234(?:\2)567(?:(\D)(0+))?(\D*)$/);
      if (mf) {
        num = function (v) {
          var p = v.toFixed(mf[4] ? mf[4].length : 0).split('.');
          return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, mf[2]) + (p[1] ? mf[3] + p[1] : '');
        };
        fmt = function (v) { return mf[1] + num(v) + mf[5]; };
      }
    }
    return { F: F, fmt: fmt };
  }

  function pop(el) {
    if (!el || !document.documentElement.classList.contains('motion')) return;
    el.classList.remove('pj-buy-pop'); void el.offsetWidth; el.classList.add('pj-buy-pop');
  }

  function init(form) {
    if (form._pjBuy) return; form._pjBuy = true;
    var kind = form.getAttribute('data-pj-buy');
    var src = form.querySelector('[data-pj-buy-list]');
    if (!src) return;
    var LIST = JSON.parse(src.textContent).sort(function (a, b) { return a.n - b.n; });
    if (!LIST.length) return;
    var cfgEl = form.querySelector('[data-pj-buy-cfg]'), cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
    var $ = function (s) { return form.querySelector(s); };
    var idIn = $('input[name="id"]'), priceEl = $('[data-pj-price]'), perEl = $('[data-pj-per]');
    var atc = $('[data-pj-atc]'), dates = $('[data-pj-dates]');

    if (kind === 'data') {
      var segs = form.querySelectorAll('[data-pj-seg]');
      var pick = function (i, animate) {
        var v = LIST[i]; if (!v) return;
        segs.forEach(function (b, k) { var on = k === i; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        idIn.value = v.vid; priceEl.textContent = v.p; if (perEl) perEl.textContent = v.per;
        if (animate) pop(priceEl);
      };
      segs.forEach(function (b, k) { b.addEventListener('click', function () { pick(k, true); }); });
      var d0 = +cfg.def || LIST[LIST.length - 1].n, i0 = 0;
      LIST.forEach(function (v, k) { if (v.n === d0) i0 = k; });
      pick(i0, false);
      return;
    }

    /* Illimité : durées réelles puis séjours découpés */
    var M = money(cfg), MAXD = LIST[LIST.length - 1].n;
    var tierFor = function (days) { for (var i = 0; i < LIST.length; i++) { if (LIST[i].n >= days) return LIST[i]; } return LIST[LIST.length - 1]; };
    var DUR = LIST.map(function (v) { return { d: v.n, vid: v.vid, p: v.p, per: v.per, k: 1 }; });
    if (MAXD >= 30) {
      for (var n = MAXD + 5; n <= MAXD * 3; n += 5) {
        var parts = [], left = n;
        while (left > 0 && parts.length < 3) { var t = tierFor(Math.min(left, MAXD)); parts.push(t); left -= t.n; }
        var k = parts.length, disc = k >= 3 ? 0.10 : k === 2 ? 0.05 : 0, cents = 0;
        parts.forEach(function (t) { var c = Math.round(t.c / 100 * M.F); cents += c - Math.floor(c * disc); });
        var tot = cents / M.F;
        DUR.push({ d: n, k: k, vid: parts[0].vid, p: M.fmt(tot), per: '≈ ' + M.fmt(tot / n) + (cfg.perDay || '') });
      }
    }
    var valEl = $('[data-pj-val]'), popEl = $('[data-pj-pop]'), noteEl = $('[data-pj-note]');
    var minus = $('[data-pj-step="-1"]'), plus = $('[data-pj-step="1"]');
    var noteTxt = noteEl ? noteEl.textContent : '', SPLIT = cfg.split || '', DS = cfg.days || '';
    var pdp = cfg.pdp || '';
    var idx = 0, d0u = +cfg.def || 15;
    DUR.forEach(function (v, k) { if (v.d === d0u) idx = k; });

    function paint(animate) {
      var v = DUR[idx];
      valEl.textContent = v.d + ' ' + DS;
      if (popEl) popEl.hidden = v.d !== d0u;
      priceEl.textContent = v.p; if (perEl) perEl.textContent = v.per;
      minus.disabled = idx <= 0; plus.disabled = idx >= DUR.length - 1;
      var split = v.k > 1;
      if (noteEl) noteEl.textContent = split ? SPLIT.replace('[K]', v.k).replace('[N]', v.d) : noteTxt;
      if (split) {
        if (dates) dates.setAttribute('href', pdp + (pdp.indexOf('?') < 0 ? '?' : '&') + 'variant=' + v.vid + '&sejour=' + v.d);
      } else {
        idIn.value = v.vid;
      }
      if (atc) atc.hidden = split;
      if (dates) dates.hidden = !split;
      form.classList.toggle('is-split', split);
      if (animate) pop(priceEl);
    }
    minus.addEventListener('click', function () { if (idx > 0) { idx--; paint(true); } });
    plus.addEventListener('click', function () { if (idx < DUR.length - 1) { idx++; paint(true); } });
    /* Un séjour découpé ne part jamais au panier sans ses dates (sécurité si le bouton était visible). */
    form.addEventListener('submit', function (e) {
      if (DUR[idx].k > 1) { e.preventDefault(); e.stopPropagation(); if (dates) location.href = dates.href; }
    });
    paint(false);
  }

  function boot(root) { (root || document).querySelectorAll('form[data-pj-buy]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
